import { useMenuItem, useSlotProps } from '@mui/base';
import cn from 'classnames';
import { forwardRef } from 'react';

import type { ForwardedRef, PropsWithChildren } from 'react';

import type { MenuItemProps } from './menu-item.types';

import './menu-item.scss';

const MenuItem = forwardRef(
  (props: PropsWithChildren<MenuItemProps>, forwardedRef: ForwardedRef<HTMLUListElement>): JSX.Element => {
    const { children, className, disabled: disabledProp = false, startIcon, ...rest } = props;

    const { disabled, getRootProps, highlighted } = useMenuItem({
      disabled: disabledProp,
      rootRef: forwardedRef,
    });

    const classes = cn('rbui-menu-item', className, {
      'rbui-menu-item--disabled': disabled,
      'rbui-menu-item--highlighted': !disabled && highlighted,
    });

    const Root = 'li';
    const rootProps = useSlotProps({
      className: classes,
      elementType: Root,
      externalForwardedProps: rest,
      externalSlotProps: undefined,
      getSlotProps: getRootProps,
      ownerState: undefined,
    });

    return (
      <Root {...rootProps} aria-label="label">
        {startIcon && (
          <span className="rbui-menu-item__start-icon" role="img">
            {startIcon}
          </span>
        )}
        {children}
      </Root>
    );
  },
);

MenuItem.displayName = 'MenuItem';

export default MenuItem;
